import type { Filter } from "pixi.js";

export enum TitleColor {
  DEFAULT = 0xffffff, // White
  PRIMARY = 0xffff00, // Yellow
  HIGHLIGHT = 0x800080, // Purple
  FADED = 0x808080, // Gray
  NOTIFY = 0xff0000, // Red
}

export interface TileProps {
  index: number;
  x: number;
  y?: number;
  isFocused: boolean;
  imageUrl: string;
  title?: string;
  titleFontSize?: number;
  titleColor?: TitleColor;
  borderThickness?: number;
  borderColor?: number;
  borderGap?: number;
  cornerRadius?: number;
  width?: number;
  height?: number;
  tileLoadingState: TileLoadingState;
  filters?: Filter[];
  onFocus?: (index: number) => void;
  onBlur?: (index: number) => void;
  skipImageLoad?: boolean;
}

export enum TileLoadingState {
  INITIAL = "initial",
  LOADING = "loading",
  LOADED = "loaded",
  ERROR = "error",
}
